import AppImgBg from '../app-img-bg'


export default
{
    name: 'app-slideshow',

    components:
    {
        AppImgBg
    },

    props:
    {
        content: { type: Array }
    },

    data()
    {
        return {
            currentImg: 0
        }
    },

    methods:
    {
        _goto(num)
        {
            const length = this.content.length

            while (num < 0)
            {
                num = length - num
            }

            num %= length

            this.currentImg = num
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-slideshow/script.js